var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SchemaTablePage", {
    ref: "tablePageRef",
    attrs: {
      "layout-mode": "page",
      "show-summary": "",
      "search-schema": _vm.searchSchema,
      columns: _vm.tableColumns,
      "default-query": _vm.defaultQuery,
      request: _vm.request,
      "build-params": _vm.buildParams,
      "parse-result": _vm.parseResult,
      "table-attrs": _vm.tableAttrs,
    },
    scopedSlots: _vm._u([
      {
        key: "search-amountRange",
        fn: function ({ query }) {
          return [
            _c(
              "div",
              { staticClass: "amount-range", staticStyle: { width: "100%" } },
              [
                _c("el-input-number", {
                  attrs: {
                    min: 0,
                    precision: 2,
                    placeholder: "最小金额",
                    controls: false,
                  },
                  model: {
                    value: query.minOperationAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "minOperationAmount", $$v)
                    },
                    expression: "query.minOperationAmount",
                  },
                }),
                _c("div", { staticStyle: { width: "10px" } }),
                _c("el-input-number", {
                  attrs: {
                    min: 0,
                    precision: 2,
                    placeholder: "最大金额",
                    controls: false,
                  },
                  model: {
                    value: query.maxOperationAmount,
                    callback: function ($$v) {
                      _vm.$set(query, "maxOperationAmount", $$v)
                    },
                    expression: "query.maxOperationAmount",
                  },
                }),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "colMemberAccount",
        fn: function ({ row }) {
          return [
            _c("MemberAccountCell", {
              attrs: {
                row: row,
                username: row.memberAccount,
                uid: row.uid,
                "vip-level": row.memberLevel,
              },
            }),
          ]
        },
      },
      {
        key: "colOperationAmount",
        fn: function ({ row }) {
          return [_vm._v(_vm._s(_vm._f("centsToYuan")(row.operationAmount)))]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }